import React, { Component, Fragment } from 'react'
import CardForm from 'Utils/Cards/CardForm';
import LoadMask from 'Utils/LoadMask/LoadMask';
import PasoUnoForm from './PasoUnoForm';
import PasoDosForm from './PasoDosForm';
import PasoTresForm from './PasoTresForm';
import PasoCuatroForm from './PasoCuatroForm';
import PasoCincoForm from './PasoCincoForm'
import "react-step-progress-bar/styles.css";
import { ProgressBar, Step } from "react-step-progress-bar";
import BonifAmoniacoForm from './Paso6Form/BonifAmoniacoForm';
import BonifFletesForm from './Paso7Form/BonifFletesForm';
import VariacionDRCForm from './Paso8Form/VariacionDRCForm';

export default class FincaCrear extends Component {
    state = {
        editar: false,
        step: 1
    };
    componentWillMount() {
        if (this.props.match.params.id) {
            this.props.leer(this.props.match.params.id);
            this.setState({ editar: true });
        }
    }
    actualizar = (data) => {
        this.props.editar(data, this.props.match.params.id)
    };
    nextStep = () => {
        this.setState({ step: this.state.step + 1 })
    };

    previousStep = () => {
        this.setState({ step: this.state.step - 1 })
    };
    componentDidMount() {
        this.props.cleanForm()
    }



    render() {
        const { crear, municipios } = this.props;
        const { updateData, loader, item } = this.props;
        const { step } = this.state;

        const steps = 8;
        const stepPositions = Array.from({ length: steps }, (_, i) => (i + 1) * (100 / steps) - 6);

        return (
            <div className="mb-4 col-12">
                <CardForm
                    icon="configuraciones_activo"
                    titulo="FINCA"
                    subtitulo="Nueva">
                    <div className="mb-4">
                        <ProgressBar
                            percent={stepPositions[step - 1]}
                            filledBackground="#035b2f"
                            stepPositions={stepPositions}
                        >
                            {[...Array(steps)].map((_, index) => (
                                <Step key={index} transition="scale">
                                    {({ accomplished }) => (
                                        <div style={{ filter: `grayscale(${accomplished ? 0 : 80}%)` }}>
                                            <div className="step-number">{index + 1}</div>
                                        </div>
                                    )}
                                </Step>
                            ))}
                        </ProgressBar>
                    </div>
                    <LoadMask loading={loader} blur>
                        {
                            this.state.editar ?
                                (<Fragment>
                                    {step === 1 && (<PasoUnoForm onSubmit={this.nextStep} updateData={updateData} />)}
                                    {step === 2 && (<PasoDosForm onSubmit={this.nextStep} updateData={updateData}
                                        previousStep={this.previousStep} municipios={municipios} />)}
                                    {step === 3 && (<PasoTresForm {...this.props} onSubmit={this.nextStep} updateData={updateData} previousStep={this.previousStep} />)}
                                    {step === 4 && (<PasoCuatroForm {...this.props} onSubmit={this.nextStep} updateData={updateData} previousStep={this.previousStep} />)}
                                    {step === 5 && (<PasoCincoForm {...this.props} onSubmit={this.nextStep} updateData={updateData} previousStep={this.previousStep} />)}
                                    {step === 6 && (<BonifAmoniacoForm {...this.props} onSubmit={this.nextStep} updateData={updateData} previousStep={this.previousStep} />)}
                                    {step === 7 && (<BonifFletesForm {...this.props} onSubmit={this.nextStep} updateData={updateData} previousStep={this.previousStep} />)}
                                    {step === 8 && (<VariacionDRCForm onSubmit={this.actualizar} updateData={updateData} previousStep={this.previousStep} />)}
                                </Fragment>) :


                                (<Fragment>
                                    {step === 1 && (<PasoUnoForm onSubmit={this.nextStep} />)}
                                    {step === 2 && (<PasoDosForm onSubmit={this.nextStep} previousStep={this.previousStep}
                                        municipios={municipios} />)}
                                    {step === 3 && (<PasoTresForm {...this.props} onSubmit={this.nextStep} previousStep={this.previousStep} />)}
                                    {step === 4 && (<PasoCuatroForm {...this.props} onSubmit={this.nextStep} previousStep={this.previousStep} />)}
                                    {step === 5 && (<PasoCincoForm {...this.props} onSubmit={this.nextStep} previousStep={this.previousStep} />)}
                                    {step === 6 && (<BonifAmoniacoForm {...this.props} onSubmit={this.nextStep} previousStep={this.previousStep} />)}
                                    {step === 7 && (<BonifFletesForm {...this.props} onSubmit={this.nextStep} previousStep={this.previousStep} />)}
                                    {step === 8 && (<VariacionDRCForm onSubmit={crear} previousStep={this.previousStep} />)}
                                </Fragment>)
                        }
                    </LoadMask>
                </CardForm>
            </div>
        )
    }
}
